/**
 * Modal de traduções de um cadastro (campo de formulário, status, serviço).
 *
 * Mostra o texto original em português e um bloco por idioma. Campo em branco
 * continua exibindo o português; regras e configurações seguem usando o original.
 *
 * `campos`: [{ campo: 'nome', rotulo: 'Nome', original: '...', multilinha?, ajuda? }]
 * `traducoes`: { 'en-US': { nome: '...' }, es: {...} }
 */
import PropTypes from "prop-types";
import { Modal, Button, Spinner } from "react-bootstrap";
import CamposTraducao from "./CamposTraducao";

const ModalTraducoes = ({ show, titulo, campos, traducoes, onChange, onCancelar, onSalvar, salvando, erro }) => (
    <Modal show={show} onHide={onCancelar} size="lg" backdrop="static">
        <Modal.Header closeButton>
            <Modal.Title>{titulo}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
            <CamposTraducao campos={campos} traducoes={traducoes} onChange={onChange} />

            {erro && <div className="text-danger small">{erro}</div>}
        </Modal.Body>

        <Modal.Footer>
            <Button variant="secondary" onClick={onCancelar}>Cancelar</Button>
            <Button variant="success" onClick={onSalvar} disabled={salvando}>
                {salvando ? <Spinner animation="border" size="sm" /> : 'Salvar traduções'}
            </Button>
        </Modal.Footer>
    </Modal>
);

ModalTraducoes.propTypes = {
    show: PropTypes.bool.isRequired,
    titulo: PropTypes.string.isRequired,
    campos: PropTypes.arrayOf(PropTypes.shape({
        campo: PropTypes.string.isRequired,
        rotulo: PropTypes.string.isRequired,
        original: PropTypes.string,
        multilinha: PropTypes.bool,
        ajuda: PropTypes.string,
    })).isRequired,
    traducoes: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    onCancelar: PropTypes.func.isRequired,
    onSalvar: PropTypes.func.isRequired,
    salvando: PropTypes.bool,
    erro: PropTypes.string,
};

export default ModalTraducoes;
